import styled from "styled-components";

export const Container = styled.div`
  min-height: 180vh;
  background-color: #66CDAA;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;
`;

export const MainText = styled.h1`
  color: #fff;
  font-size: 4.5rem;
  font-family: 'Diphylleia';
  position: absolute;
  font-weight: bolder;
  text-align: center;
  top: 20%;
  transform: translateY(-50%);
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  transition: opacity 1s ease;
`;

export const AdditionalText = styled.h1`
  color: #fff;
  font-size: 3rem;
  font-family: 'Noto Sans KR';
  position: absolute;
  font-weight: bolder;
  top: 57%;
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  transition: opacity 1s ease;
  transform: translateY(-50%);
`;

export const Line = styled.div`
  content: "";
  width: 2px;
  height: 70px;
  background-color: #fff;
  position: absolute;
  margin-top: 30px;
  top: 38.5%;
  left: 50%;
  transform: translateX(-50%);
`;

export const InfoContainer = styled.div`
  position: absolute;
  top: 70%;
  width: 100%;
  left: 50%;
  transform: translateX(-50%);
  height: 100vh;
  background-color: #fff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
`;

export const InfoTitle = styled.h1`
  color: #66CDAA;
  font-weight: bolder;
  font-size: 2rem;
  text-align: center;
  margin-top: 10px;
  font-family: 'Noto Sans KR';
`;

export const ButtonWrapper = styled.div`
  display: flex;
  width : 100%;
  background-color: #ffffff;
  justify-content: space-around;
`;

export const MainButton = styled.button`
  background-color: #ffffff;
  color: #66CDAA;
  font-family: 'Noto Sans KR';
  font-size: 20px;
  font-weight: bold;
  width : 100%;
  height : 18rem;
  border: none;
  border-radius: 5px;
  cursor: pointer;
`;